"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Step_1 = __importDefault(require("./Step"));
const GisFilesService_1 = __importDefault(require("../services/GisFilesService"));
const gisFilesService = new GisFilesService_1.default();
class FilesSummaryStep extends Step_1.default {
    constructor(config) {
        super(config.id);
        this.data = config.data;
    }
    uploadFiles(files) {
        files.forEach(file => {
            file.name = this.formatFileName(file.name);
            this.data.files.push(file);
        });
    }
    errorCall() {
        return [gisFilesService.error, gisFilesService.msg, gisFilesService.code];
    }
    formatFileName(originalName) {
        return originalName.replace(/ /g, "_").replace(/[^A-Za-z0-9_.]/g, "");
    }
    setMetadataField(fileName, fileColum, targetMetadata) {
        for (const field of this.data.fieldsProcessed) {
            if (this.formatFileName(field.origin) === fileName) {
                for (const meta of field.metadata) {
                    if (meta.columnName === fileColum) {
                        if (targetMetadata === 'FieldName') {
                            field.setName(meta.columnValue.toString());
                        }
                        else if (targetMetadata === 'FarmName') {
                            field.setFarmName(meta.columnValue.toString());
                        }
                    }
                }
            }
        }
    }
    async sendFiles(prjCode) {
        this.data.fieldsProcessed = [];
        await gisFilesService.fetchFiles(this.data.files, prjCode);
        for (const uploadFile of this.data.files) {
            for (const fileMetadata of gisFilesService.filesMetadata) {
                if (uploadFile.name === fileMetadata.fileName.replace(/ /g, "_")) {
                    uploadFile.setMetadata(fileMetadata.columns);
                }
            }
        }
        gisFilesService.fields.forEach(field => {
            this.data.fieldsProcessed.push(field);
        });
    }
    resetStep() {
        this.data.fieldsProcessed = [];
        this.data.files = [];
    }
}
exports.default = FilesSummaryStep;
